"use client";

import { Map, Placemark, YMaps } from "@iminside/react-yandex-maps";
import type React from "react";
import { useState } from "react";
import Loader from "../Loader/Loader";
import styles from "./styles.module.css";

interface MapComponentProps {
	latitude: string;
	longitude: string;
	className?: string;
}

export const MapComponent: React.FC<MapComponentProps> = ({
	latitude,
	longitude,
	className,
}) => {
	const [isLoading, setIsLoading] = useState(true);

	// Convert string coordinates to numbers for the map
	const lat = parseFloat(latitude);
	const lng = parseFloat(longitude);

	// State for the map that updates when props change
	const mapState = {
		center: [lat, lng],
		zoom: 15,
	};

	const handleMapLoad = () => {
		setIsLoading(false);
	};

	return (
		<div className={`${styles.mapContainer} ${className || ""}`}>
			{isLoading && <Loader />}
			<YMaps>
				<Map state={mapState} className={styles.map} onLoad={handleMapLoad}>
					<Placemark
						key={`${lat}-${lng}`}
						geometry={[lat, lng]}
						options={{
							iconLayout: "default#image",
							iconImageHref: "/icons/MapPoint.svg", // правильный путь
							iconImageSize: [64, 64],
							iconImageOffset: [-32, -64],
						}}
					/>
				</Map>
			</YMaps>
		</div>
	);
};

export default MapComponent;
